<template>
  <div
    v-show="isOpen"
    ref="modal"
    class="Modal -open"
    :class="modalClasses"
    @keyup.esc="closeModal"
  >
    <span class="Modal__close" @click="closeModal"></span>
    <section ref="dialog" class="Modal__dialog">
      <button
        v-show="!hideCloseButton"
        type="button"
        class="Modal__cancel c-button c-button--center"
        @click="closeModal"
      >
        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
          style="display: block; fill: rgb(118, 118, 118); height: 16px; width: 16px;"
        >
          <path
            fill-rule="evenodd"
            d="M23.25 24a.744.744 0 0 1-.53-.22L12 13.062 1.28 23.782a.75.75 0 0 1-1.06-1.06L10.94 12 .22 1.28A.75.75 0 1 1 1.28.22L12 10.94 22.72.22a.749.749 0 1 1 1.06 1.06L13.062 12l10.72 10.72a.749.749 0 0 1-.53 1.28"
          ></path>
        </svg>
      </button>

      <header v-if="$slots.header" ref="header" class="Modal__header">
        <slot name="header"></slot>
      </header>

      <div class="Modal__subHeader">
        <slot name="subheader"></slot>
      </div>

      <div class="Modal__content">
        <slot name="content">
          <icon name="spinner" size="huge" :spin="true"></icon>
        </slot>
      </div>

      <footer v-if="showControls" ref="footer" class="Modal__footer">
        <slot name="footer">
          <button
            v-if="submit"
            id="btnMesclar"
            type="button"
            :disabled="disableSubmitButton"
            class="c-button c-button--secondary"
            @click="saveChanges"
          >
            {{ labels.submit }}
          </button>
        </slot>
      </footer>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    showControls: {
      type: Boolean,
      default: true
    },
    size: { default: "small" },
    labels: {
      type: Object,
      default: function() {
        return {
          cancel: "Cancelar",
          submit: "Salvar"
        };
      }
    },
    submit: {
      type: Boolean,
      default: true
    },
    theme: {
      type: String,
      default: "light"
    },
    disableSubmitButton: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    hideCloseButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      closing: false,
      isOpen: true,
      documentClass: ""
    };
  },
  created() {
    EventBus.$on("modal-reopen", () => {
      this.closing = false;
      this.isOpen = true;
    });
  },
  mounted() {
    this.hiddenScroll();
    EventBus.$on("close-modal", () => {
      this.closeModal();
    });
  },
  computed: {
    modalClasses() {
      return {
        "is-small": this.size == "small",
        "is-large": this.size == "large",
        "-tiny": this.size == "tiny",
        "-dark": this.theme == "dark",
        "-isClosing": this.closing,
        "has-no-padding": this.noPadding,
        "-noHeader": !this.$slots.header
      };
    }
  },
  methods: {
    showScroll() {
      document.documentElement.setAttribute("class", this.documentClass);
      // document.documentElement.style.overflow = 'auto';
    },
    hiddenScroll() {
      this.documentClass = document.documentElement.getAttribute("class");
      document.documentElement.setAttribute("class", "-hasModalOpen");
      // document.documentElement.style.overflow = 'hidden';
    },
    saveChanges() {
      // TODO: Emmit a event with the changes
      this.$emit("save-modal-changes");
      this.fakeClose();
    },
    fakeClose() {
      this.closing = true;
      this.isOpen = false;
      this.showScroll();
    },
    closeModal() {
      this.closing = true;
      this.showScroll();
      this.$emit("close-modal");
    }
  }
};
</script>

<style lang="stylus" src="./monitoramentos/modal.styl" scoped />
